import {
  startOfWeek,
  startOfMonth,
  endOfWeek,
  endOfMonth,
  eachDayOfInterval,
} from 'date-fns/fp';
import { compose } from 'lodash/fp';

const firstDate = compose(startOfWeek, startOfMonth);
const lastDate = compose(endOfWeek, endOfMonth);

export const makeMonth = (date) =>
  eachDayOfInterval({
    start: firstDate(date),
    end: lastDate(date),
  });
